import { dangerouslyParseGermanApiFloat } from '@zurich-framework/core/api';
import { policySegmentsUtils, segmentKeyUtils, } from '@zurich-client/typeutils/contract';
export const getPolicySegmentsClickableRows = (segment, t, locale) => {
    const motorRelatedInsuranceTax = segment?.premium?.technicalValues?.find((item) => item?.key === 'xP_AH_VST_Wert_annual')?.value;
    return [
        {
            label: t('policy.segmentStart'),
            value: segment?.startDate && locale.formatDateTime(segment.startDate),
        },
        {
            label: t('policy.segmentEnd'),
            value: segment?.endDate && locale.formatDateTime(segment.endDate),
        },
        {
            label: t('policy.annualNet'),
            value: segment?.premium?.annualNetPremium &&
                locale.formatMoneyAmount(segment?.premium?.annualNetPremium),
        },
        {
            label: t('policy.annualGross'),
            value: segment?.premium?.annualGrossPremium &&
                locale.formatMoneyAmount(segment?.premium?.annualGrossPremium),
        },
        {
            label: t('policy.insuranceTax'),
            value: segment?.premium?.insuranceTax &&
                locale.formatMoneyAmount(segment?.premium?.insuranceTax),
        },
        segment?.premium?.fireTax && {
            label: t('policy.fireTax'),
            value: locale.formatMoneyAmount(segment?.premium?.fireTax),
        },
        motorRelatedInsuranceTax && {
            label: t('policy.motorInsuranceTax'),
            value: locale.formatMoneyAmount(dangerouslyParseGermanApiFloat(motorRelatedInsuranceTax)),
        },
        segment?.indexationInfo?.index && {
            label: t('policy.index'),
            value: segment?.indexationInfo?.index,
        },
        segment?.indexationInfo?.indexValue && {
            label: t('policy.indexValue'),
            value: segment?.indexationInfo?.indexValue,
        },
        segment?.discounts?.find((discount) => discount.type === 'specialDiscount')
            ?.value && {
            label: t('policy.specialDiscount'),
            value: segment?.discounts?.filter((discount) => discount.type === 'specialDiscount'),
        },
        segment?.discounts?.find((discount) => discount.type === 'onlineDiscount')
            ?.value && {
            label: t('policy.onlineDiscount'),
            value: segment?.discounts?.filter((discount) => discount.type === 'onlineDiscount'),
        },
        segment?.discounts?.find((discount) => discount.type === 'customerSpecificDiscount')?.value && {
            label: t('policy.customerSpecificDiscount'),
            value: segment?.discounts?.filter((discount) => discount.type === 'customerSpecificDiscount'),
        },
        segment?.segmentKey === '01.0_AH' &&
            segment?.discounts?.find((discount) => discount.type === 'winterDiscount')
                ?.value && {
            label: t('policy.winterDiscount'),
            value: segment?.discounts?.filter((discount) => discount.type === 'winterDiscount'),
        },
        segment?.discounts?.find((discount) => discount.type === 'campaingDiscount')
            ?.discountSelected && {
            label: t('policy.campaingDiscount'),
            value: segment?.discounts?.filter((discount) => discount.type === 'campaingDiscount'),
        },
        ...(segmentKeyUtils.isSegmentByPrefix(segment, 'AH')
            ? policySegmentsUtils.getSegmentAHRows(locale, t, segment)
            : []),
        ...(segmentKeyUtils.isSegmentByPrefix(segment, ['VK', 'TK'])
            ? policySegmentsUtils.getSegmentKaskoRows(locale, t, segment)
            : []),
        ...(segmentKeyUtils.isSegmentByPrefix(segment, 'IU')
            ? policySegmentsUtils.getSegmentIURows(locale, t, segment)
            : []),
    ].filter((x) => !!x);
};
